import marque from '../marque.json';

/**
 * Le nom du logiciel, écrit à un seul endroit : src/marque.json (et son double
 * backend/src/main/resources/marque.json, qu'un test garde identique).
 *
 * <p>Les textes, les traductions et les écrans sont écrits avec « SwissTech » :
 * le nom choisi y prend sa place à l'affichage. Les adresses (swisstech.ch) et
 * les noms techniques, en minuscules, ne changent pas.
 */

/** Le nom avec lequel tous les textes sont écrits. */
export const NOM_D_ORIGINE = 'SwissTech';

/** Le nom affiché. */
export const NOM_LOGICIEL = String(marque?.nom || '').trim() || NOM_D_ORIGINE;

/** Vrai quand le logiciel porte un autre nom que celui des textes. */
export const RENOMME = NOM_LOGICIEL !== NOM_D_ORIGINE;

/**
 * @param {*} texte texte affiché
 * @param {string} [nom] nom du logiciel
 * @returns {*} le texte avec le nom du logiciel ; tel quel s'il n'en parle pas
 */
export function avecLeNom(texte, nom = NOM_LOGICIEL) {
  if (typeof texte !== 'string' || nom === NOM_D_ORIGINE || !texte.includes(NOM_D_ORIGINE)) {
    return texte;
  }
  return texte.split(NOM_D_ORIGINE).join(nom);
}
